/***********************************************************
Animations (In-View)
***********************************************************/
function initAnimations() {
  const elements = document.querySelectorAll('[data-in-view="translate"]');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('hello');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  elements.forEach(el => observer.observe(el));
}